<ion-header>
  <ion-toolbar>
    <ion-title>Clock Out</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="onClickCancel()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <app-timecard-control
    *ngIf="getStep() === 'timecards'"
    [(ngModel)]="activeTimecard"
    [maxDate]="maxDate"
    [jobDate]="jobDate.date"
  ></app-timecard-control>
  <app-equipment-time-control
    *ngIf="getStep() === 'equipment'"
    [equip]="equipment"
    [(ngModel)]="payload.equipment"
    [totalMinutes]="totalMinutes()"
  ></app-equipment-time-control>
  <app-untracked-time-control
    *ngIf="getStep() === 'untracked'"
    [untrackedEquip]="equipUntracked"
    [(ngModel)]="payload.untracked"
  >
  </app-untracked-time-control>
  <app-total-time-control
    *ngIf="getStep() === 'totaltime'"
    [clockIn]="activeTimecard.clockIn"
    [clockOut]="activeTimecard.clockOut"
    [showUnscheduled]="
      ['R', 'E'].includes(jobDate.job.jobNumber[0].toUpperCase())
    "
    [(ngModel)]="payload"
  ></app-total-time-control>
  <app-clock-out-summary
    *ngIf="getStep() === 'summary'"
    [activeTimecard]="activeTimecard"
    [equipment]="equipment"
    [equipUntracked]="equipUntracked"
    [payload]="payload"
    [fieldLogReqs]="fieldLogReqs"
    [job]="jobDate"
  ></app-clock-out-summary>
  <ng-container *ngIf="getStep() === 'costing'">
    <ion-toolbar>
      <ion-title>Addtional Costing</ion-title>
    </ion-toolbar>
    <h3 class="ion-text-center">
      Are there any materials, subs, or restorations to enter?
    </h3>
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-button
            expand="block"
            [color]="forwardCosting ? 'primary' : 'light'"
            (click)="forwardCosting = true"
            >Yes
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button
            expand="block"
            [color]="forwardCosting ? 'light' : 'primary'"
            (click)="forwardCosting = false"
            >No
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-container>
  <ng-container *ngIf="getStep() === 'extras'">
    <ion-toolbar>
      <ion-title>Extras</ion-title>
    </ion-toolbar>
    <h3 class="ion-text-center">
      Are there any extras or restorations to enter?
    </h3>
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-button
            expand="block"
            [color]="forwardCosting ? 'primary' : 'light'"
            (click)="forwardCosting = true"
            >Yes
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button
            expand="block"
            [color]="forwardCosting ? 'light' : 'primary'"
            (click)="forwardCosting = false"
            >No
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-container>
  <ng-container *ngIf="getStep() === 'noBoxReason'">
    <ion-item lines="none">
      <ion-label class="ion-text-wrap">
        <h2>No Box Trailer Billed</h2>
        <p>
          No box trailer or trench box was entered for this job on its first
          active day. Please go back and add one, or enter a reason below to
          continue.
        </p>
      </ion-label>
    </ion-item>
    <ion-item>
      <ion-label position="stacked">Reason *</ion-label>
      <ion-textarea
        [(ngModel)]="noBoxReason"
        placeholder="Explain why no box trailer was used..."
        rows="4"
      ></ion-textarea>
    </ion-item>
  </ng-container>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button *ngIf="step > 0" (click)="step = step - 1">Back</ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button
        *ngIf="getStep() !== 'summary'"
        (click)="onClickNext()"
        [disabled]="nextDisabled()"
        >Next
      </ion-button>
      <ion-button *ngIf="getStep() === 'summary'" (click)="onClickSave()">
        Save
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
